import React, { useState } from 'react';
import PhoneShell from './components/PhoneShell';
import AppHeader from './components/AppHeader';
import TabBar from './components/TabBar';
import HamburgerMenu from './components/HamburgerMenu';
import MenuScreenView from './components/MenuScreenView';
import AIDrawer from './components/AIDrawer';
import DesktopShell from './components/desktop/DesktopShell';
import HomeScreen from './screens/HomeScreen';
import ScheduleScreen from './screens/ScheduleScreen';
import ParkingLotScreen from './screens/ParkingLotScreen';
import AttendeesScreen from './screens/AttendeesScreen';
import { BG } from './lib/tokens';
import { useEventMode } from './lib/useEventMode';
import { ScheduleProvider } from './lib/ScheduleContext';
import { useSchedule } from './lib/useSchedule';
import { useBreakpoint } from './lib/useBreakpoint';

export default function App() {
  return (
    <ScheduleProvider>
      <AppInner />
    </ScheduleProvider>
  );
}

function AppInner() {
  const bp = useBreakpoint();
  if (bp === 'desktop') return <DesktopShell />;
  return <MobileApp />;
}

function MobileApp() {
  const [activeTab, setActiveTab] = useState(0);
  const { day: detectedDay } = useSchedule();
  const [activeDay, setActiveDay] = useState(detectedDay);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuScreen, setMenuScreen] = useState(null);
  const [aiOpen, setAiOpen] = useState(false);
  const [isPostEvent, setIsPostEvent] = useEventMode(false);

  // Update default day once the schedule loads (in case event is in progress)
  React.useEffect(() => {
    setActiveDay(detectedDay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detectedDay]);

  const renderTab = () => {
    switch (activeTab) {
      case 0:
        return <HomeScreen isPostEvent={isPostEvent} />;
      case 1:
        return <ScheduleScreen activeDay={activeDay} setActiveDay={setActiveDay} />;
      case 2:
        return <ParkingLotScreen />;
      case 3:
        return <AttendeesScreen />;
      default:
        return null;
    }
  };

  return (
    <PhoneShell>
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          background: BG,
          paddingTop: 'calc(env(safe-area-inset-top, 0px) + 8px)',
        }}
      >
        <AppHeader onMenuOpen={() => setMenuOpen(true)} isPostEvent={isPostEvent} />
        {renderTab()}
        <TabBar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onAITap={() => setAiOpen(true)}
        />
      </div>

      {menuScreen && (
        <MenuScreenView
          screen={menuScreen}
          onBack={() => setMenuScreen(null)}
          isPostEvent={isPostEvent}
          setIsPostEvent={setIsPostEvent}
        />
      )}

      <HamburgerMenu
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        onNavigate={setMenuScreen}
        isPostEvent={isPostEvent}
      />

      <AIDrawer open={aiOpen} onClose={() => setAiOpen(false)} />
    </PhoneShell>
  );
}
